import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore, useAppStore } from '../../store/useStore';
import { Sidebar } from './Sidebar';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';

export function Layout() {
  const navigate = useNavigate();
  const { isAuthenticated, _hasHydrated, checkAuth } = useAuthStore();
  const { sidebarCollapsed, theme } = useAppStore();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for hydration before checking auth
    if (_hasHydrated) {
      const isLoggedIn = checkAuth();
      if (!isLoggedIn && !isAuthenticated) {
        navigate('/login');
      }
      setIsReady(true);
    }
  }, [_hasHydrated, isAuthenticated, navigate, checkAuth]);

  useEffect(() => {
    // Apply theme to document
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  // Show loading while hydrating
  if (!_hasHydrated || !isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main
        className={cn(
          "min-h-screen transition-all duration-300",
          sidebarCollapsed ? "ml-16" : "ml-60"
        )}
        data-testid="main-content"
      >
        <Outlet />
      </main>
    </div>
  );
}
